var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdbf00"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientTransform: "matrix(0 -1 1 0 -534.527 2117.397)",
    gradientUnits: "userSpaceOnUse",
    x1: 1715.516,
    x2: 1715.516,
    xlinkHref: "#lg1",
    y1: 808.986,
    y2: 868.894
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientTransform: "matrix(0 -1 1 0 -534.527 2117.397)",
    gradientUnits: "userSpaceOnUse",
    x1: 1729.099,
    x2: 1729.099,
    xlinkHref: "#lg1",
    y1: 866.734,
    y2: 828.819
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9100",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9100"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 329.341,
    x2: 306.015,
    xlinkHref: "#lg2",
    y1: 358.095,
    y2: 299.415
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientTransform: "matrix(0 -1 1 0 -534.527 2117.397)",
    gradientUnits: "userSpaceOnUse",
    x1: 1857.274,
    x2: 2076.034,
    xlinkHref: "#lg1",
    y1: 793.176,
    y2: 1011.936
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientTransform: "matrix(0 -1 1 0 -534.527 2117.397)",
    gradientUnits: "userSpaceOnUse",
    x1: 1948.799,
    x2: 1741.786,
    xlinkHref: "#lg1",
    y1: 884.701,
    y2: 677.688
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 388.786,
    x2: 315.433,
    xlinkHref: "#lg2",
    y1: 292.994,
    y2: 219.641
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientTransform: "matrix(.707 -.707 .707 .707 -796.039 915.062)",
    gradientUnits: "userSpaceOnUse",
    x1: 1075.117,
    x2: 1075.117,
    xlinkHref: "#lg1",
    y1: 221.332,
    y2: 281.239
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientTransform: "matrix(.707 -.707 .707 .707 -796.039 915.062)",
    gradientUnits: "userSpaceOnUse",
    x1: 1088.7,
    x2: 1088.7,
    xlinkHref: "#lg1",
    y1: 279.079,
    y2: 241.164
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientTransform: "matrix(.707 -.707 .707 .707 -796.039 915.062)",
    gradientUnits: "userSpaceOnUse",
    x1: 1216.875,
    x2: 1435.635,
    xlinkHref: "#lg1",
    y1: 205.522,
    y2: 424.282
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientTransform: "matrix(.707 -.707 .707 .707 -796.039 915.062)",
    gradientUnits: "userSpaceOnUse",
    x1: 1308.399,
    x2: 1101.387,
    xlinkHref: "#lg1",
    y1: 297.046,
    y2: 90.034
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 383.863,
    x2: 368.555,
    xlinkHref: "#lg2",
    y1: 233.837,
    y2: 186.82
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b799d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07485e"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 249.571,
    x2: 446.704,
    xlinkHref: "#lg3",
    y1: 98.594,
    y2: 98.594
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 445.924,
    x2: 275.98,
    xlinkHref: "#lg3",
    y1: 196.372,
    y2: 26.428
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m331.507 445.198v-10.469c0-2.877 1.33-5.592 3.603-7.355 4.804-3.727 4.804-10.983 0-14.71-2.273-1.763-3.603-4.478-3.603-7.355v-10.469c0-3.661 2.968-6.628 6.628-6.628 3.661 0 6.628-2.968 6.628-6.629v-7.52c0-3.661-2.968-6.629-6.628-6.629-3.661 0-6.628-2.968-6.628-6.628v-20.002c0-3.661 2.968-6.629 6.628-6.629 3.661 0 6.628-2.968 6.628-6.628v-33.786h-74.963v170.669c0 6.764 2.479 13.293 6.967 18.353l19.916 22.451c5.637 6.355 15.561 6.355 21.198 0l19.916-22.451c4.489-5.06 6.967-11.589 6.967-18.353v-5.975c0-3.661-2.968-6.629-6.628-6.629-3.661.001-6.629-2.967-6.629-6.628z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.24 293.762v177.115c0 6.604-5.354 11.958-11.958 11.958-6.604 0-11.958-5.354-11.958-11.958v-177.115z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.764 374.064c0-3.661-2.968-6.629-6.629-6.629s-6.628-2.968-6.628-6.628v-20.002c0-3.661 2.968-6.628 6.628-6.628 3.661 0 6.629-2.968 6.629-6.629v-33.786h-74.964v17.682l73.838 73.838c.711-1.056 1.127-2.328 1.127-3.697v-7.521z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m307.282 103.328c-59.735 0-108.162 48.426-108.162 108.162s48.426 108.162 108.162 108.162 108.162-48.426 108.162-108.162-48.426-108.162-108.162-108.162zm0 97.746c-16.935 0-30.668-13.722-30.668-30.668 0-16.935 13.733-30.656 30.668-30.656s30.668 13.722 30.668 30.656c0 16.946-13.733 30.668-30.668 30.668z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m307.282 122.235c-49.296 0-89.255 39.959-89.255 89.255s39.959 89.255 89.255 89.255 89.255-39.959 89.255-89.255-39.959-89.255-89.255-89.255zm0 78.839c-16.935 0-30.668-13.722-30.668-30.668 0-16.935 13.733-30.656 30.668-30.656s30.668 13.722 30.668 30.656c0 16.946-13.733 30.668-30.668 30.668z",
    fill: "url(#SVGID_5_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m307.282 103.328c-59.735 0-108.162 48.426-108.162 108.162s48.426 108.162 108.162 108.162 108.162-48.426 108.162-108.162-48.426-108.162-108.162-108.162zm0 97.746c-16.935 0-30.668-13.722-30.668-30.668 0-16.935 13.733-30.656 30.668-30.656s30.668 13.722 30.668 30.656c0 16.946-13.733 30.668-30.668 30.668z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m130.398 382.314 7.402-7.402c2.034-2.034 4.894-3.013 7.748-2.653 6.032.762 11.163-4.369 10.401-10.401-.36-2.854.619-5.714 2.653-7.748l7.402-7.402c2.589-2.589 6.786-2.589 9.374 0 2.589 2.589 6.786 2.589 9.374 0l5.317-5.317c2.589-2.589 2.589-6.786 0-9.374-2.589-2.589-2.589-6.786 0-9.374l14.144-14.144c2.589-2.589 6.786-2.589 9.374 0 2.589 2.589 6.786 2.589 9.374 0l23.89-23.89-53.008-53.008-120.678 120.678c-4.783 4.783-7.647 11.152-8.051 17.904l-1.792 29.958c-.507 8.479 6.51 15.496 14.989 14.989l29.958-1.792c6.752-.404 13.121-3.268 17.904-8.051l4.225-4.225c2.589-2.589 2.589-6.785 0-9.374-2.589-2.589-2.589-6.785 0-9.374z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m228.805 266.558-125.239 125.239c-4.67 4.67-12.241 4.67-16.911 0-4.67-4.67-4.67-12.241 0-16.911l125.239-125.239z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m355.006 123.446c-42.239-42.239-110.724-42.239-152.964 0s-42.239 110.724 0 152.964 110.724 42.239 152.964 0 42.24-110.725 0-152.964zm-69.116 69.116c-11.975-11.975-11.983-31.388 0-43.371 11.975-11.975 31.388-11.966 43.363.008 11.975 11.975 11.983 31.388.008 43.363-11.983 11.983-31.397 11.975-43.371 0z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m341.637 136.815c-34.858-34.858-91.368-34.858-126.226 0s-34.858 91.368 0 126.226 91.368 34.858 126.226 0 34.858-91.369 0-126.226zm-55.747 55.747c-11.975-11.975-11.983-31.388 0-43.371 11.975-11.975 31.388-11.966 43.363.008 11.975 11.975 11.983 31.388.008 43.363-11.983 11.983-31.397 11.975-43.371 0z",
    fill: "url(#SVGID_10_)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m326.701 194.848 72.947 72.947c10.02-16.402 15.796-35.678 15.796-56.305 0-14.362-2.806-28.067-7.889-40.605-9.436 8.989-33.218 25.275-80.854 23.963z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m348.11 0c-53.381 0-96.998 42.665-98.539 95.697 14.346-3.969 29.337-4.931 43.999-2.876 2.887-27.543 26.242-49.084 54.54-49.084 30.255 0 54.857 24.613 54.857 54.857 0 21.245-12.148 39.713-29.85 48.821-7.501 3.86-16.008 6.036-25.007 6.036-6.145 0-12.05-1.017-17.571-2.887h-.011c-6.473-2.198-12.399-5.576-17.538-9.863-9.535-1.717-19.725 1.115-27.095 8.485-4.997 4.997-7.905 11.284-8.726 17.779 13.187 13.712 30.321 23.607 49.532 27.882 6.9 1.531 14.062 2.34 21.409 2.34 13.493 0 26.362-2.723 38.084-7.654 35.514-14.925 60.51-50.068 60.51-90.94 0-54.364-44.229-98.593-98.594-98.593z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.972 98.594c0-41.882-33.952-75.835-75.835-75.835-39.638 0-72.153 30.416-75.526 69.179 6.991-.38 14.012-.092 20.959.882 2.887-27.543 26.242-49.084 54.54-49.084 30.255 0 54.857 24.613 54.857 54.857 0 21.245-12.148 39.713-29.85 48.821-7.501 3.86-16.008 6.036-25.007 6.036-6.145 0-12.05-1.017-17.571-2.887h-.011c-6.473-2.198-12.399-5.576-17.538-9.863-8.174-1.472-16.825.41-23.772 5.618 13.904 17.144 35.128 28.109 58.92 28.109 41.882.002 75.834-33.95 75.834-75.833z",
    fill: "url(#SVGID_13_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKey);
export default __webpack_public_path__ + "static/media/icon-key.4369def5f9596680ee1bd85181f2017c.svg";
export { ForwardRef as ReactComponent };